import React from 'react';
import { MINDSET_CARD_ID, useMindsetCardAgent, useMindsetSituationalAwareness, useMindsetPageTools } from 'utils/mindset';
import MindsetAgentCard from 'components/MindsetAgentCard';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function OnboardingMindsetCard() {
  var _useMindsetCardAgent = useMindsetCardAgent({
      forceOnboardingPlan: true
    }),
    mindsetLoadingStatus = _useMindsetCardAgent.mindsetLoadingStatus,
    setMindsetLoadingStatus = _useMindsetCardAgent.setMindsetLoadingStatus,
    hasInitialized = _useMindsetCardAgent.hasInitialized,
    renderGeneration = _useMindsetCardAgent.renderGeneration;
  useMindsetSituationalAwareness(hasInitialized, MINDSET_CARD_ID, renderGeneration);
  var _useMindsetPageTools = useMindsetPageTools(hasInitialized, MINDSET_CARD_ID, renderGeneration),
    modals = _useMindsetPageTools.modals;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MindsetAgentCard, {
      mindsetLoadingStatus: mindsetLoadingStatus,
      onLoad: function onLoad() {
        return setMindsetLoadingStatus('success');
      }
    }), modals]
  });
}
export default OnboardingMindsetCard;